import React from 'react';

import { TabsForm } from '../../../../../components';
import DownloadTab from './tabs/DownloadTab';
import ExportTab from './tabs/ExportTab';

export const MediaExportTabs = () => {
  return (
    <TabsForm
      tabs={[
        {
          title: 'Downloads',
          content: <DownloadTab />,
        },
        {
          title: 'Exports',
          content: <ExportTab />,
        },
      ]}
    />
  );
};

export default MediaExportTabs;
